import { z } from 'zod';

const ArchivoSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  url_externa: z.string(),
  path_local: z.string()
});


const JsonMetadataSchema = z.any();

const LicitacionDataSchema = z.object({
  resumen_procesado_filtro_palabras: z.boolean().nullable(),
  archivos_descargados: z.boolean().nullable(),
  codigo_estado: z.number(),
  resumen_aprobado_filtro_palabras: z.boolean().nullable(),
  archivos_procesados: z.boolean().nullable(),
  fecha_cierre: z.string().nullable(),
  fecha_archivos_procesados: z.string().nullable(),
  id: z.number(),
  resumen_procesado_filtro_llm: z.boolean().nullable(),
  filtro_archivos_aprobado: z.boolean().nullable(),
  fecha_creacion: z.string().nullable(),
  resumen: z.string().nullable(),
  json_metadata: JsonMetadataSchema.nullable(),
  fecha_actualizacion: z.string().nullable(),
  resumen_aprobado_filtro_llm: z.boolean().nullable(),
  resumen_llm: z.string().nullable(),
  puntaje_archivos: z.number().nullable().optional(),
  puntaje: z.number().nullable(),
  resumen_archivos_llm: z.string().nullable().optional(),
  estado_notificacion: z.string(),
  usuario_ultima_actualizacion_id: z.number().nullable().optional(),
  fecha_resumen_procesado: z.string().nullable(),
  estado_licitacion: z.string(),
  nombre: z.string(),
  filtro_resumen_aprobado: z.boolean().nullable(),
  codigo_externo: z.string(),
  visto: z.array(z.number()).nullable(),
  postulado: z.boolean().nullable(),
  fecha_postulacion: z.string().nullable(),
  adjudicado: z.boolean().nullable(),
  fecha_adjudicacion: z.string().nullable()
});

const LicitacionSchema = z.object({
  data: LicitacionDataSchema,
  archivos: z.array(ArchivoSchema),
  preguntas_y_respuestas: z.any().nullable().optional()
});

export const PaginatedLicitacionesResponseSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  data: z.array(LicitacionSchema),
  extra: z.record(z.any()).nullable().optional()
});

export const ListarLicitacionesResponseSchema = PaginatedLicitacionesResponseSchema;

export type ListarLicitacionesResponse = z.infer<typeof ListarLicitacionesResponseSchema>;
export type Licitacion = z.infer<typeof LicitacionSchema>;
export type LicitacionData = z.infer<typeof LicitacionDataSchema>;
export type JsonMetadata = z.infer<typeof JsonMetadataSchema>;
export type Archivo = z.infer<typeof ArchivoSchema>; 